import React from "react";
import _ from "lodash";
import ProductCardComponent from "../NewDesign/ProductCard/ProductCardComponent";
import ListingFilterSectionComponent from "../NewDesign/ListingContent/ListingFilterSection/ListingFilterSectionComponent";
import { useEffect, useMemo, useState, useRef, useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import {
  getAllCertifications,
  getAllCertificationsResponse,
  getAllCertificationsClear,
} from "../../redux/certificateURL/actions";
import {
  getAllEventsNIIT,
  getEventDetailsNIITClear,
  getAllEventsNIITClear,
} from "../../redux/events/actions";
import {
  FreeForYou,
  FreePaidSubscription,
  SessionKeys,
  convertTimeInHourAndMin,
  getPriceInfoForEntity,
  PriceInfo,
  getProcureInfo,
} from "../../utils/AppUtils";
import Loader from "../Loader/Loader";
import CONFIG from "../../utils/config";
import ErrorSection from "../ErrorPage/ErrorSection";
import "./CertificationListSection.scss";
import EventSliderFilterSection from "../NewDesign/Event/EventSliderFilter";
import { useTranslation } from "react-i18next";
export default function CertificationListComp(props) {
  const { t } = useTranslation();
  const { key } = props;
  const dispatch = useDispatch();
  const observer = useRef();
  const navigate = useNavigate();
  const search = window.location.search;
  const params = new URLSearchParams(search);
  const c = params.get("c");
  let providerId = "";
  let allPartners = "";
  if (c) {
    let decodedString = atob(c);
    let paramsReq = JSON.parse(decodedString);
    providerId = paramsReq.provider_id;
    allPartners = paramsReq?.allPartners;
  }
  const [selectedPartner, setSelectedPartner] = useState(
    providerId ? "" : "all"
  );

  const [certificationList, setCertificationList] = useState(
    CONFIG.INITIAL_PRODUCT_CARD_DATA
  );
  const certificationsListRes = useSelector(
    (state) => state.certificateURL.certificationsList
  );
  const [isFetching, setIsFetching] = useState(true);
  const [isLoading, setIsLoading] = useState(false);
  const [certificationCount, setCertificationCount] = useState(0);
  const [pageNum, setPageNum] = useState(1);
  const [totalRecords, setTotalRecords] = useState(0);
  const [pageSize, setPageSize] = useState(12);
  const [hasNoMore, setHasNoMore] = useState(true);

  const [apiListing, setAPIListing] = useState([]);
  const [listing, setListing] = useState([]);

  const [selectedSort, setSelectedSort] = useState("");
  const [selectedFilter, setSelectedFilter] = useState("");
  const [searchTxt, setSearchTxt] = useState("");
  const [sortOption] = useState([
    { value: 1, label: "Name (A to Z)" },
    { value: 2, label: "Name (Z to A)" },
  ]);
  const [filterOption] = useState([
    { value: 1, label: "All" },
    // { value: 2, label: "Available for Purchase" },
    { value: 3, label: "Purchased Certifications" },
  ]);

  const isPremiumUser = useSelector((state) => state.user.isPremiumUser);
  // const navigateToView = (data) => {
  //     let url = `/certify-detail/?certify_id=${data.event_id}`
  //     url = url  + `&certify_code=${data.event_code}` + `&source=${data?.origin}`
  //     navigate(url)
  //     // navigate(`/video-view-page/2681/?source=xsel&code=VD-YIO0R7Z&catId=1501`)
  // }

  const navigateToView = (data) => {
    let paramsReq = {
      event_id: data.event_id,
      event_code: data?.event_code,
      source: data.source,
      fromCert: "true",
      provider_id: providerId ? providerId : "",
      provider_name: data?.provider_name ? data?.provider_name : "",
    };
    let jsonString = JSON.stringify(paramsReq);
    let encodedUrl = btoa(jsonString);

    let url = `/event-detail?c=${encodedUrl}`;
    // let url = `/event-detail?event_id=${data.event_id}`;
    // url = url + `&event_code=${data?.event_code}` + `&source=${data.source}`;
    navigate(url);
  };

  const formatDataForProductCard = (certificatList) => {
    let certificationArr = [];
    let records = certificatList.records;
    setTotalRecords(certificatList.total_records);
    setCertificationCount(certificatList.total_records);
    for (let item of records) {
      let tags = [];
      let logoURL = "";
      let btnTitle = t("Explore");
      // logoURL = item.logoURL;
      // tags.push(item.provider);
      // tags.push(item.delivery_mode)
      // tags.push(convertTimeInHourAndMin(item.duration))

      let priceInfo = getProcureInfo(item.purchased_info);
      // let footerComp = FreeForYou();
      let footerComp = "";
      // if (item.source === 'xsel') {
      //     footerComp = PriceInfo(priceInfo.price, item.date_time)
      // }

      certificationArr.push({
        id: item?.event_id,
        dbId: item?.list_id,
        is_like: item?.is_like ? item?.is_like : false,
        is_bookmark: item?.is_bookmark ? item?.is_bookmark : false,
        productType: item?.type,
        productOrigin: item?.source,
        title: item.title,
        logoURL: logoURL,
        logoAltText: "VD",
        bannerURL: item.thumbnail,
        tagsArray: tags,
        description: item.description,
        duration: convertTimeInHourAndMin(item.duration ? item.duration : 0),
        showHeader: true,
        showProviderIcon: false,
        showLikeMenu: true,
        showPlayButton: false,
        showProgress: false,
        showBody: true,
        showFooter: true,
        btnTitle: btnTitle,
        btnAction: () => navigateToView(item),
        descAction: () => {},
        bannerAction: (e) => navigateToView(item),
        cardClassName: "",
        footerLineComp: footerComp,
        isLoading: false,
        rightBtnIcon: "/images/arrow-right.svg",
        lefttBtnIcon: "",
        priceInfo,
      });
    }

    let newLPArr = certificationArr;
    if (pageNum > 1) {
      newLPArr = [...apiListing, ...certificationArr];
      setCertificationList(newLPArr);
      setAPIListing(newLPArr);
    } else {
      setCertificationList(certificationArr);
      setAPIListing(certificationArr);
    }

    if (certificatList.total_records === newLPArr.length) {
      setHasNoMore(true);
    } else {
      setHasNoMore(false);
    }
  };

  useEffect(() => {
    if (
      !_.isEmpty(certificationsListRes) &&
      certificationsListRes?.status === "success"
    ) {
      setIsLoading(false);
      let certificationsListDetail = certificationsListRes.payload.payload;
      if (!_.isEmpty(certificationsListDetail)) {
        setListing(certificationsListDetail.records);
        formatDataForProductCard(certificationsListDetail);
        setIsFetching(false);
      } else {
        setCertificationList([]);
        setCertificationCount(0);
      }
      dispatch(getAllCertificationsClear());
    }
  }, [certificationsListRes]);
  const activeLanguage = useSelector((state) => state.home.activeLanguage);
  const fetchCertifications = (searchStr, page) => {
    setCertificationList(CONFIG.INITIAL_PRODUCT_CARD_DATA);
    setIsLoading(true);
    dispatch(
      getAllCertifications({
        module: "getAllCertifications",
        postData: {
          token: localStorage.getItem(SessionKeys.API_TOKEN_BROKER),
          type: "Certification",
          search: searchStr,
          provider_id: providerId
            ? providerId
            : selectedPartner != "all"
            ? selectedPartner
            : "",
          sort_by: "",
          filter: "",
          page_size: pageSize,
          page: page,
          isAll: allPartners
            ? selectedPartner != "all"
              ? false
              : true
            : false,
          language: activeLanguage ? activeLanguage : "",
        },
      })
    );
  };

  useEffect(() => {
    fetchCertifications(searchTxt, pageNum);
  }, [dispatch, pageNum, searchTxt, selectedPartner, activeLanguage]);

  const onSearchClicked = (searchText) => {
    const searchStr = _.toLower(searchText);
    // searchText.toLowerCase();
    setSearchTxt(searchStr);
  };

  // const formattedListing = useMemo(() => {
  //     if (!_.isEmpty(certificationList)) {
  //         let videoList = _.cloneDeep(certificationList)
  //         videoList = _.filter(videoList, (video) => {
  //             if (selectedFilter === 2) {
  //                 return video.priceInfo.price > 0 && !video.priceInfo.isPaid
  //             } else if (selectedFilter === 3) {
  //                 return video.priceInfo.isPaid
  //             } else {
  //                 return video
  //             }
  //         })
  //         let sortBy = 'asc';
  //         if (selectedSort === 2) {
  //             sortBy = 'desc'
  //         }
  //         console.log(selectedSort, sortBy)
  //         return _.orderBy(videoList, ['view', 'title'], ['desc', sortBy])
  //     }
  //     return []
  // }, [certificationList, selectedSort, selectedFilter])

  const onFilterClicked = (filterValue) => {
    // setVideoListing(apiVideoListing.filter(video => {
    //     if (filterValue === 2) {
    //         return video.priceInfo.price > 0 && !video.priceInfo.isPaid
    //     } else if (filterValue === 3) {
    //         return video.priceInfo.isPaid
    //     } else {
    //         return video
    //     }
    // }))
  };

  const paginateCB = useCallback(
    (node) => {
      if (isFetching || isLoading) return;

      if (observer.current) observer.current.disconnect();

      observer.current = new IntersectionObserver((entries) => {
        console.log(hasNoMore);
        if (entries[0].isIntersecting && !hasNoMore) {
          setIsFetching(true);
          console.log(
            "End of file",
            totalRecords,
            certificationList.length,
            pageNum,
            isLoading,
            isFetching
          );
          setPageNum((pageNum) => pageNum + 1);
          setCertificationList([
            ...certificationList,
            ...CONFIG.INITIAL_PRODUCT_CARD_DATA,
          ]);
        }
      });

      if (node) observer.current.observe(node);
      console.log(node);
    },
    [isLoading, hasNoMore]
  );

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return (
    <>
      {/* <Loader start={isLoading} /> */}
      <div className="certification-comp">
        <div className="tab-content" id="nav-tabContent">
          {allPartners ? (
            <EventSliderFilterSection
              selectedPartner={selectedPartner}
              setSelectedPartner={setSelectedPartner}
            />
          ) : (
            ""
          )}
          <ListingFilterSectionComponent
            onSearchClicked={onSearchClicked}
            showSearch={true}
            showSort={false}
            showFilter={false}
            showCategories={false}
            sortOption={sortOption}
            filterOption={filterOption}
            sortSelected={selectedSort}
            setSelectedSort={setSelectedSort}
            setSelectedFilter={(value) => {
              setSelectedFilter(value);
              onFilterClicked(value);
            }}
            entityType={"certification"}
          />
        </div>
        <div className="">
          {isLoading || certificationList.length === 0 ? (
            ""
          ) : (
            <span>
              {t("We found")} {certificationCount} certification
              {certificationCount > 1 ? "s" : ""} {t("for you")}
            </span>
          )}
          <div className="coursecard-row row">
            {certificationList.length === 0 ? (
              <ErrorSection />
            ) : (
              certificationList.map((item, index) => {
                return (
                  <>
                    <ProductCardComponent
                      {...item}
                      key={`certification-${index + 1}`}
                      lastKey={certificationList.length === index + 1}
                      refInfo={paginateCB}
                      cardClassName="certificatecard"
                    />
                  </>
                );
              })
            )}
          </div>
        </div>
      </div>
    </>
  );
}
